module.exports = __webpack_public_path__ + "static/image6@2x-783041f17a39d57012113d7115c643ae.png";